import axios from 'axios'
import { API_BASE_URL } from 'configs/AppConfig'
import { setIsAccountStatusChanged, setIsAlreadyLoggedIn, signOutSuccess } from 'store/slices/authSlice'
import store from 'store'
import { AUTH_TOKEN, USER_DATA } from 'constants/AuthConstant'
import { notification } from 'antd'
import { setMessage } from 'store/slices/footerSlice'
import { onButtonLoding } from 'store/slices/menuButtonSlice'
import Utils from '../utils'
import { translate } from '../components/util-components/IntlMessage'
import AuthService from '../services/AuthService'

const unauthorizedCode = [400, 401, 403]

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 0,
})

// Config
const TOKEN_PAYLOAD_KEY = 'Authorization'

// 예외시킬 url 정의
const exceptionURL = [
  'login',
  'logout',
  '/auth/',
  '/access-token/',
  '/locale/',
  '/image/',
  // '/file/',
  '/code/',
  '/menu/',
  '/home/',
]

// API Request interceptor
service.interceptors.request.use(
  config => {
    // 제외처리
    const isException = exceptionURL.some(url => config.url.includes(url))

    if (!isException) {
      store.dispatch(setMessage(''))
      store.dispatch(onButtonLoding(true))

      AuthService.extendingLogin().then(data => {
        localStorage.setItem(AUTH_TOKEN, data?.token)
      })
    }

    const jwtToken = localStorage.getItem(AUTH_TOKEN) || null

    if (jwtToken) {
      config.headers[TOKEN_PAYLOAD_KEY] = `Bearer ${jwtToken}`
    }

    return config
  },
  error => {
    // Do something with request error here
    notification.error({
      message: 'Error',
    })
    Promise.reject(error)
  },
)

// API respone interceptor
service.interceptors.response.use(
  async response => {
    let responseData = response.data

    // 현재 요청들어온 path 경로
    const pathName = new URL(response.request.responseURL).pathname
    // 제외여부
    const isException = exceptionURL.some(url => pathName.includes(url))

    // 중복로그인 에러
    if (responseData.status === 700) {
      store.dispatch(setIsAlreadyLoggedIn(true))

      return Promise.reject(responseData)
    }

    // 유저상태 변경 에러
    if (responseData.status === 701) {
      store.dispatch(setIsAccountStatusChanged(true))

      return Promise.reject(responseData)
    }

    // 인증실패 또는 토큰만료 사용자
    if (responseData.status === 401) {
      localStorage.removeItem(AUTH_TOKEN)
      localStorage.removeItem(USER_DATA)
      store.dispatch(signOutSuccess())

      return Promise.reject(responseData)
    }

    if (responseData.type === 'application/json' && responseData instanceof Blob) {
      try {
        responseData = await Utils.convertBlobToJson(responseData)
      } catch (error) {
        console.log('error', error)
      }
    }

    if (responseData.message && responseData.status) {
      // 제외처리
      if (!isException) {
        store.dispatch(setMessage(responseData.message))
        store.dispatch(onButtonLoding(false))
      }

      return Promise.reject(responseData)
    }

    // 제외처리
    if (!isException) {
      store.dispatch(setMessage(responseData.message || translate('M0007')))
      store.dispatch(onButtonLoding(false))
    }

    return responseData
  },
  error => {
    let notificationParam = {
      message: 'Error',
    }

    // Remove token and redirect
    if (unauthorizedCode.includes(error.response?.status)) {
      notificationParam.message = 'Authentication Fail'
      notificationParam.description = 'Please login again'
      localStorage.removeItem(AUTH_TOKEN)
      localStorage.removeItem(USER_DATA)
      store.dispatch(signOutSuccess())
    }

    if (error.response?.status === 404) {
      notificationParam.message = 'Not Found'
    }

    if (error.response?.status === 500) {
      notificationParam.message = 'Internal Server Error'
    }

    if (error.response?.status === 508) {
      notificationParam.message = 'Time Out'
    }

    // store.dispatch(setMessage(error.response.data.message))

    // notification.error(notificationParam)

    store.dispatch(onButtonLoding(false))

    return Promise.reject(error)
  },
)

export default service
